"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _styles = _interopRequireDefault(require("./styles"));
var _Info = _interopRequireDefault(require("@material-ui/icons/Info"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var Callout = props => {
  var classes = (0, _styles.default)(props);
  var {
    children
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.calloutBox
  }, /*#__PURE__*/_react.default.createElement(_Info.default, {
    className: classes.calloutTextIcon
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: 'body2',
    className: classes.calloutTextSpacing,
    component: 'span'
  }, children)));
};
var _default = exports.default = Callout;